import { Card, CardBody } from '@/components/ui/card';
import type { NavItem } from '@/nav';

/** Placeholder for sections whose screens are built in a later increment. */
export function PlannedPage({ item }: { item: NavItem }) {
  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <div>
        <h1 className="text-xl font-semibold tracking-tight">{item.label}</h1>
        <p className="mt-1 text-sm text-muted">{item.summary}</p>
      </div>
      <Card>
        <CardBody className="flex items-center gap-3">
          <item.icon className="size-5 text-muted" aria-hidden />
          <p className="text-sm">
            Planned for <strong>Increment {item.increment}</strong>. See{' '}
            <code className="font-mono text-xs">docs/15-ROADMAP.md</code>.
          </p>
        </CardBody>
      </Card>
    </div>
  );
}
